import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { FiArrowLeft } from 'react-icons/fi';

import giveahandLogo from '~/assets/logo.png';

import colors from '~/styles/colors';

import {
  Container,
  Content,
  RegisterWrapper,
  BackLink,
  FormWrapper,
  InputGroup,
  InputWrapper,
  InputPhoneWrapper,
  TextareaWrapper,
  Button,
} from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function Register() {
  const formRef = useRef(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [city, setCity] = useState('');
  const [uf, setUf] = useState('');

  useEffect(() => {
    document.title = 'Give A Hand | Register';
  });

  async function handleRegister(data, { reset }) {
    try {
      const schema = Yup.object().shape({
        name: Yup.string().required('O nome é obrigatório.'),
        email: Yup.string()
          .email('Insira um e-mail válido.')
          .required('O e-mail é obrigatório.'),
        whatsapp: Yup.string()
          .required('O Whatsapp é obrigatório.')
          .min(13, 'Insira um WhatsApp válido.')
          .max(14, 'Insira um WhatsApp válido.'),
        city: Yup.string().required('A cidade é obrigatória.'),
        uf: Yup.string().required('A UF é obrigatória.'),
        reason: Yup.string(),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      formRef.current.setErrors({});

      await api.post('/responsibles', data);

      toast.success(
        'ID criado com sucesso. Estamos analisando seu cadastro. Em breve você irá receber seu ID de login por e-mail.'
      );

      history.push('/');
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        // console.log(err);

        const errorMessages = {};

        err.inner.forEach(error => {
          errorMessages[error.path] = error.message;
        });

        formRef.current.setErrors(errorMessages);
      }
    }
  }

  return (
    <Container>
      <Content>
        <RegisterWrapper>
          <img src={giveahandLogo} alt="Give A Hand" />
          <h1>Cadastro</h1>
          <p>
            Faça seu cadastro, entre na plataforma e de{' '}
            <strong>uma mãozinha</strong> para quem está precisando de uma{' '}
            <strong>realocação</strong> de emergência devido a crise da Covid-19
            em nosso país.
          </p>
          <BackLink to="/">
            <FiArrowLeft size={16} color={colors.danger} />
            Já possuo cadastro
          </BackLink>
          <BackLink to="/indications">
            <FiArrowLeft size={16} color={colors.danger} />
            Visualizar lista de indicações
          </BackLink>
        </RegisterWrapper>
        <FormWrapper>
          <Form ref={formRef} onSubmit={handleRegister}>
            <InputWrapper
              autoFocus
              name="name"
              placeholder="Nome completo"
              value={name}
              onChange={e => setName(e.target.value)}
            />

            <InputWrapper
              name="email"
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />

            <InputPhoneWrapper
              name="whatsapp"
              placeholder="Número do WhatsApp"
              mask="(99) 9999tt999?"
              formatChars={{ '9': '[0-9]', t: '[0-9-]', '?': '[0-9 ]' }}
              maskChar={null}
              value={whatsapp}
              onChange={e => setWhatsapp(e.target.value)}
            />

            <InputGroup>
              <InputWrapper
                name="city"
                placeholder="Cidade"
                value={city}
                onChange={e => setCity(e.target.value)}
              />

              <InputWrapper
                name="uf"
                placeholder="UF"
                value={uf}
                onChange={e => setUf(e.target.value)}
              />
            </InputGroup>
            <TextareaWrapper name="reason" placeholder="Motivo (opcional)" />
            <Button>Cadastrar</Button>
          </Form>
        </FormWrapper>
      </Content>
    </Container>
  );
}
